var render = function render(){var _vm=this,_c=_vm._self._c;return _c('store-log-table',{attrs:{"type":1,"producty-type":"原料"}})
}
var staticRenderFns = []

export { render, staticRenderFns }